import { motion } from "framer-motion";

const FOUNDER_IMG =
  "https://i.postimg.cc/SQVjLQKQ/My-Imgae.jpg";

const PARAGRAPHS = [
  "When I founded RecruitSteps, I recognized a fundamental truth: organizations in complex, high-stakes industries — like aerospace, banking, and renewable energy — don't just need 'workers.' They need elite, specialized experts who can navigate constant evolution.",
  "But as the landscape of work shifted, I saw another piece of the puzzle. Even the most brilliant human teams were being slowed down by legacy processes, repetitive tasks, and operational friction. I realized that if we truly wanted to serve our clients, we couldn't just fill seats — we had to optimize the entire engine.",
  "That is why I expanded our mandate to include AI-driven solutions.",
  "By integrating sophisticated automation workflows, intelligent voice bots, and tailored AI ecosystems into our service model, we are no longer just a staffing partner; we are a growth engine. We believe that AI shouldn't replace the human touch — it should amplify it. We use AI to handle the complexity so your talent can focus on the strategy, creativity, and decision-making that no machine can replicate.",
  "Whether you are looking to secure top-tier leadership for a critical banking project or looking to automate your enterprise workflows, our mission remains the same: to build the teams and technology that empower your business to operate at its peak.",
  "We are here to bridge the gap between human ingenuity and artificial intelligence. Let's build the future, together.",
];

export default function FounderNote() {
  return (
    <section
      data-testid="founder-section"
      id="founder"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="pointer-events-none absolute top-1/2 -translate-y-1/2 -left-40 w-[480px] h-[480px] rounded-full bg-indigo-700/15 blur-[140px]" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          data-testid="founder-image"
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5"
        >
          <div className="relative w-full aspect-[4/5] max-w-md mx-auto lg:mx-0">
            <div className="absolute -inset-1 rounded-2xl bg-gradient-to-br from-indigo-500/40 via-transparent to-indigo-700/40 blur-md" />
            <div className="relative h-full w-full rounded-2xl overflow-hidden border border-white/10 glass">
              <img
                src={FOUNDER_IMG}
                alt="Rahul Sharma — Founder, RecruitSteps & AI Solutions"
                className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120] via-transparent to-transparent opacity-70" />
              <div className="absolute bottom-5 left-5 right-5">
                <div className="text-[10px] uppercase tracking-[0.3em] text-indigo-300/90">
                  Founder
                </div>
                <div className="font-display text-2xl text-white mt-1">
                  Rahul Sharma
                </div>
                <div className="text-xs text-slate-300 mt-1">
                  RecruitSteps &amp; AI Solutions
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          data-testid="founder-text"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-indigo-400">
            Founder&rsquo;s Note
          </span>
          <h2 className="mt-4 font-display text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-white">
            The Symbiosis of
            <span className="text-gradient"> Human Potential </span>
            and Digital Intelligence.
          </h2>

          <div className="mt-7 space-y-4 text-slate-300 text-base md:text-lg leading-relaxed max-w-2xl">
            {PARAGRAPHS.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="mt-8 flex items-center gap-4">
            <div className="h-px w-12 bg-indigo-400" />
            <div>
              <div className="font-display text-white text-lg">
                Rahul Sharma
              </div>
              <div className="text-xs uppercase tracking-[0.25em] text-slate-400">
                Founder · RecruitSteps &amp; AI Solutions
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
